import React from "react";
import "./InfoGroup.scss";
import { InfoItem } from "../InfoItem/InfoItem";
import { LitterDensityInfoItem } from "../LitterDensityInfoItem/LitterDensityInfoItem";

export interface InfoItemData {
  title: string;
  value: number;
  description?: string;
}

export interface LitterDensityItemUIData {
  medianLitterDensity: number;
  minimumLitterDensity: number;
  maximumLitterDensity: number;
}

type InfoGroupProps = {
  itemData: InfoItemData[]; //This only accept upto 4 entries [no less - no more]
  stackedUI: boolean; //The default is true
  surveyEffortUI?: boolean;
  isComparison?: boolean;
  litterDensityInfo?: LitterDensityItemUIData;
};

export const InfoGroup: React.FC<InfoGroupProps> = ({
  itemData,
  stackedUI,
  surveyEffortUI,
  isComparison,
  litterDensityInfo,
}) => {
  return (
    <section
      className={`${
        stackedUI ? "info_group_section" : "info_group_section_unstacked"
      } ${
        surveyEffortUI
          ? isComparison
            ? "info_group_section_survey_effort__comparison"
            : "info_group_section_survey_effort"
          : ""
      }`}
    >
      {litterDensityInfo !== null && litterDensityInfo !== undefined ? (
        <div
          className={`${
            stackedUI ? "info_item_container" : "info_item_container_unstacked"
          }`}
        >
          <LitterDensityInfoItem
            medianLitterDensity={litterDensityInfo.medianLitterDensity}
            minimumLitterDensity={litterDensityInfo.minimumLitterDensity}
            maximumLitterDensity={litterDensityInfo.maximumLitterDensity}
          />
        </div>
      ) : null}
      {itemData.map((item) => (
        <div
          key={item.title}
          className={`${
            stackedUI ? "info_item_container" : "info_item_container_unstacked"
          }`}
        >
          <InfoItem
            title={item.title}
            value={item.value}
            description={item.description}
          />
        </div>
      ))}
    </section>
  );
};
